export interface IncomePlan {
  employment: 'clt' | 'business' | 'other'
  business: string
  source: string
  mode: 'monthly' | 'business-day' | 'split' | 'weekly' | 'manual'
  days: number[]
  weekday: number
  monthlyAmount: number
  minimum: number
  includeSaturday: boolean
  holidays: string[]
  startDate: string
}
export function dateKey(date: Date) { return `${date.getFullYear()}-${String(date.getMonth()+1).padStart(2,'0')}-${String(date.getDate()).padStart(2,'0')}` }
export const todayKey = () => new Intl.DateTimeFormat('en-CA', {timeZone:'America/Sao_Paulo',year:'numeric',month:'2-digit',day:'2-digit'}).format(new Date())
export function defaultIncomePlan(): IncomePlan { return {employment:'other',business:'',source:'Recebimentos',mode:'manual',days:[5,20],weekday:3,monthlyAmount:0,minimum:0,includeSaturday:true,holidays:[],startDate:todayKey()} }
export function incomeDates(month: string, plan: IncomePlan): string[] {
  const [y,m] = month.split('-').map(Number), count = new Date(y,m,0).getDate()
  const days = Array.from({length:count},(_,i)=>new Date(y,m-1,i+1,12))
  let selected: Date[] = []
  if(plan.mode==='weekly') selected=days.filter(d=>d.getDay()===plan.weekday)
  if(plan.mode==='monthly'||plan.mode==='split') selected=[...new Set(plan.days.slice(0,plan.mode==='split'?2:1).map(d=>Math.min(count,d)))].sort((a,b)=>a-b).map(d=>days[d-1])
  if(plan.mode==='business-day') {
    const workdays=days.filter(d=>d.getDay()!==0&&(plan.includeSaturday||d.getDay()!==6)&&!plan.holidays.includes(dateKey(d)))
    if(workdays[4]) selected=[workdays[4]]
  }
  return selected.map(dateKey).filter(d=>d>=plan.startDate)
}
